module.exports = __webpack_public_path__ + "img/4.a4f1d2c.jpg";